import { call, put, takeEvery, select, fork } from "redux-saga/effects"
import { toast } from "react-toastify"
// Crypto Redux States
import FabricInventoryType from "./actionTypes"

import FabricInventoryAction from "./actions"
import moment from "moment"
import FabricInventoryAPI from "helpers/fabric_inventory_helper"

function* fetchListOnPage({ payload }) {
  yield put(
    FabricInventoryAction.getListPageSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    const currentPage = payload.page
    let { data } = yield call(FabricInventoryAPI.getListPage, {
      ...payload,
      page: currentPage,
    })

    yield put(
      FabricInventoryAction.getListPageSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      FabricInventoryAction.getListPageSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchDetail({ payload, action }) {
  yield put(
    FabricInventoryAction.getDetailSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(FabricInventoryAPI.getDetail, payload.id)

    yield put(
      FabricInventoryAction.getDetailSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
    yield put(
      FabricInventoryAction.getDetailSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchPutData({ payload, action }) {
  yield put(
    FabricInventoryAction.putDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(FabricInventoryAPI.putData, payload)

    yield put(
      FabricInventoryAction.putDataSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    console.log(error)
    yield put(
      FabricInventoryAction.putDataSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchDetailPage({ payload, action }) {
  yield put(
    FabricInventoryAction.getDetailPageSuccess({
      loading: true,
    })
  )
  try {
    let { data } = yield call(FabricInventoryAPI.getDetailPage, payload)
    action({ ...data, parentId: payload.id })
    yield put(
      FabricInventoryAction.getDetailPageSuccess({
        loading: false,
      })
    )
  } catch (error) {
    yield put(
      FabricInventoryAction.getDetailPageSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fabricInventorySaga() {
  yield takeEvery(
    FabricInventoryType.GET_FABRIC_INVENTORY_PAGES,
    fetchListOnPage
  )
  yield takeEvery(
    FabricInventoryType.GET_DETAIL_FABRIC_INVENTORY_BY_ID,
    fetchDetail
  )
  yield takeEvery(FabricInventoryType.PUT_FABRIC_INVENTORY, fetchPutData)
  yield takeEvery(
    FabricInventoryType.GET_FABRIC_INVENTORY_DETAIL_PAGES,
    fetchDetailPage
  )
}

export default fabricInventorySaga
